import React, { useEffect } from "react";
import * as GC from "../../../../common/common";
import * as CommonFunctions from "../functions/commonFunctions";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import $ from "jquery";

const PlaceInWorkplanModal = () => {
  useEffect(() => {
    $("#plaats_in_werkplan").on("show.bs.modal", function (event) {
      GC.GetEntityList(
        process.env.REACT_APP_CATALOG_WORK_PLANS,
        1,
        30,
        CallBackFunctions.WerkplanCallback,
        window.$mm_management_units_token
      );
    });
  });

  const handleSubmit = () => {
    $("#cover-spin").show(0);
    var werkplanId = $("input[name=werkplan]:checked").attr("id");
    var element = $("input[name=werkplan]:checked");
    var label = $(element).next("label").attr("for", werkplanId);
    var model = { werkplan: werkplanId };
    var selectedIds = [];
    $("#example")
      .dataTable()
      .$("tr.selected")
      .each(function () {
        selectedIds.push($(this).attr("rowId"));
      });

    GC.StartActivity(
      model,
      selectedIds,
      "1041f11d-46f4-4a46-a1c5-8e6d91f0877f",
      werkplanVerplaatst,
      window.$mm_management_units_token
    );
    function werkplanVerplaatst() {
      GC.sleep(500).then(() => {
        $("#plaats_in_werkplan").modal("hide");
        window.$mm_budget_refresh();
        /*omnimap
          .FillTableAction(
            window.$mm_budget_lastUsedTableFilter,
            1,
            window.$mm_management_units_token
          )
          .then((result) => {
            CallBackFunctions.FillTableCallBack(result, 1);
          });*/
      });
    }
  };

  return (
    <div
      className="modal fade"
      tabIndex={-1}
      role="dialog"
      id="plaats_in_werkplan"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Plaats in werkplan</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            <input
              type="search"
              className="modal-search"
              placeholder="Zoeken naar werkplannen"
            />
            <div className="modal-scroll">
              <div id="werkplan-grp" className="radio-grp" />
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              id="save_werkplan"
              className="btn-modal"
              onClick={handleSubmit}
            >
              Verwerken
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlaceInWorkplanModal;
